<template>
  <div class="learner-container">
    <div class="messages-area" v-for="message in messages" :key="message.id">
      <transition name="up">
        <div v-if="message.question" class="bubble robot-bubble">
          <div class="character-container">
            <figure class="avatar">
              <!-- <img src="../assets/images/default-user.svg" alt="" /> -->
            </figure>
            {{ characterName }}
          </div>
          {{ message.question }}
        </div>
      </transition>
      <transition name="up">
        <div v-if="message.answer" class="bubble learner-bubble">
          {{ message.answer }}
        </div>
      </transition>
      <transition name="up">
        <div v-if="message.response" class="bubble robot-bubble">
          <div v-for="(characterResponse, index) in message.response" :key="index">
            <div class="character-container">
              <figure class="avatar">
                <!-- <img src="../assets/images/default-user.svg" alt="" /> -->
              </figure>
              <h4 class="character-name">{{ characterName }}</h4>
            </div>
            <div class="character-response">
              {{ characterResponse.response }}
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div class="assessment-container">
      <div class="final-feedback-title">
        <h1>Conversation Assessment</h1>
      </div>
      <div class="assessment-content">
        <div v-if="ifLearnerAssessments" class="container">
          <div v-for="(feedback, name, index) in feedbackData" class="row" :key="feedback[index]">
            <h2>{{ feedback.data.attributes.custom_label || feedback.data.attributes.skill_set_title }}</h2>
            <p class="feedback-result" v-if="feedback.data.attributes.show_pass_fail_labels">{{
              feedback.data.attributes.assessment_result || feedback.data.attributes.hit_feed_req_item_label }}</p>
            <p v-if="feedback.data.attributes.show_points">{{ feedback.data.attributes.earned_points }}/{{
              feedback.data.attributes.possible_points }}</p>
            <p v-safe-html="feedback.data.attributes.llm_feedback"></p>
          </div>
        </div>
        <div v-else class="container">
          <div v-for="(feedback, name, index) in feedbackData" class="row" :key="feedback[index]">
            <h2 v-if="feedback.show_labels">{{ feedback.skill_label || feedback.skill_name }}</h2>
            <h2 v-else>{{ feedback.skill_name }}</h2>
            <p v-if="feedback.show_labels" class="feedback-result">{{ feedback.result }}</p>
            <p>{{ feedback.feedback }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../services/api";
import { notifyAirbrake } from "../services/airbrake";
export default {
  name: "llm-dialogic",
  props: ["active_data", "user_details", "lo_details"],
  data() {
    return {
      messages: [
        {
          question: "",
          answer: "",
          response: "",
        },
      ],
      userAnswer: "",
      loading: false,
      assessmentLoading: false,
      feedback: "",
      hasStarted: false,
      finishedLoading: false,
      numberOfAttempts: 0,
      attemptsLimit: 3,
      llmComplete: false,
      showAssessment: false,
      showFeedback: false,
      dialogicQuestions: [],
      characterName: "",
      feedbackData: [],
      gradeData: [],
      totalScore: 0,
      grade: "",
      maxScore: 0,
      isMoatCustom: false,
      ifLearnerAssessments: false,
      qaItems: [],
    };
  },
  methods: {
    getLlmConversation() {
      let payload = {
        lo_id: this.active_data.id,
        user_learn_obj_id: this.lo_details.id
      };
      api.getLlmChatHistory(payload).then((res) => {
        let chatHistoryData = (res && res.data && res.data.data) || [];
        chatHistoryData.forEach((chatEl) => {
          this.hasStarted = true;
          let response = "";
          if (chatEl.attributes.response && chatEl.attributes.response.length > 0) {
            response = chatEl.attributes.response;
          }
          this.messages.push({
            answer: chatEl.attributes.body,
            response: response,
          });
        });
      });
    },
    submitAssessmentRequest() {
      const evalId = this.lo_details.attributes.current_evaluation_id;
      if (!evalId) return;
      api.getLlmDialogicAssessment(evalId).then((res) => {
        const response = res && res.data && res.data.data;
        if (!response || !response.attributes) return;
        const learnerAssessments = response.attributes.learner_assessments;
        if (learnerAssessments && learnerAssessments.length > 0) {
          this.feedbackData = learnerAssessments;
          this.ifLearnerAssessments = true;
        } else {
          this.feedbackData = response.attributes.assessment_results || [];
        }
      }).catch((err) => {
        notifyAirbrake(err, { context: 'LLM dialogic assessment' });
      });
    },
  },
  mounted() {
    this.llmComplete = this.user_details.complete;
    let cardDetail = this.active_data.attributes.card_detail;
    if (cardDetail.attributes.dialogic_switch) {
      this.dialogicQuestions = cardDetail.attributes.llm_dialogic_questions;
      this.messages[this.messages.length - 1].question = this.dialogicQuestions[0].question;
    }
    const MOAT_LO_IDS = [563, 562, 561, 560, 557, 556, 554, 553, 552, 551, 549]
    const MOAT_LEARN_MOD_ID = this.active_data.attributes.learn_mod_id;
    if (MOAT_LO_IDS.includes(MOAT_LEARN_MOD_ID)) {
      this.isMoatCustom = true;
    }
    try {
      this.qaItems = cardDetail.attributes.llm_dialogic_questions;
      if (this.qaItems.length > 0) {
        this.messages[this.messages.length - 1].question = this.qaItems[0].question;
      } else {
        this.messages[this.messages.length - 1].question = this.dialogicQuestions[0];
      }
    } catch (e) {
      this.qaItems = cardDetail.attributes.llm_dialogic_questions;
      this.messages[this.messages.length - 1].question = this.dialogicQuestions[0] || "";
    }
    this.characterName = cardDetail.attributes.character_name;
    this.getLlmConversation();
    this.submitAssessmentRequest();
  },
};
</script>

<style scoped lang="scss">
.learner-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px;
}

.messages-area {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-bottom: 45px;
}

.messages-area:first-child {
  margin-top: 45px;
}

.bubble {
  border-radius: 15px;
  padding: 16px;
  margin-bottom: 16px;
  max-width: 50%;
}

.learner-bubble {
  background: #3dbc9e;
  color: #faf9f6;
  font-weight: bold;
  justify-self: flex-end;
  align-self: flex-end;
  text-align: right;
  width: fit-content;
}

.robot-bubble {
  background: #3d9bbc;
  color: #faf9f6;
  font-weight: bold;
  justify-self: flex-start;
  align-self: flex-start;
  width: fit-content;
  position: relative;
  .character-response {
    margin-bottom: 12px;
    background: #3d9bbc;
    padding: 16px;
    color: #faf9f6;
    font-weight: bold;
    justify-self: flex-start;
    align-self: flex-start;
    width: fit-content;
    position: relative;
    min-width: 300px;
    border-radius: 15px
  }
}

.chat {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 32px;
}

.button {
  padding: 8px;
  border-radius: 5px;
  background: white;
  border: 2px solid green;
  margin-top: 16px;
}

.button:hover {
  background: green;
  color: white;
  cursor: pointer;
  transition: all 0.2s;
}

.button-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: center;
  width: 100%;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}

.up-enter-active,
.fade-leave-active {
  transition: all 0.5s;
}

.up-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
  transform: translateY(30px);
}

.feedback {
  width: 50%;
  margin: 25px auto;
  text-align: left;
  line-height: 1.6;
}

.spacer {
  display: block;
  width: 50%;
  margin: 0 auto;
  height: 1px;
  background: black;
}

.header {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 128px;
}

.messages-container {
  display: flex;
  width: 100%;
  padding: 10px;
  position: relative;
  min-height: 75px;
  max-height: 450px;
}

.input-area {
  color: black;
  width: 400px;
  min-height: 75px;
  padding: 16px;
  max-height: 450px;
}

.submit-button {
  border: none;
  font-size: 14px;
  padding: 6px 10px;
  border: 1px solid green;
  margin-top: 0;
}

@mixin center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

@mixin ball {
  @include center;
  content: "";
  display: block;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: rgb(240, 240, 240);
  z-index: 2;
  margin-top: 4px;
  animation: ball 0.45s cubic-bezier(0, 0, 0.15, 1) alternate infinite;
}

/*--------------------
Bounce
--------------------*/
@keyframes bounce {
  0% {
    transform: matrix3d(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }

  4.7% {
    transform: matrix3d(0.45, 0, 0, 0, 0, 0.45, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }

  9.41% {
    transform: matrix3d(0.883, 0, 0, 0, 0, 0.883, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }

  14.11% {
    transform: matrix3d(1.141, 0, 0, 0, 0, 1.141, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }

  18.72% {
    transform: matrix3d(1.212, 0, 0, 0, 0, 1.212, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }

  24.32% {
    transform: matrix3d(1.151, 0, 0, 0, 0, 1.151, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }

  29.93% {
    transform: matrix3d(1.048, 0, 0, 0, 0, 1.048, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }

  35.54% {
    transform: matrix3d(0.979, 0, 0, 0, 0, 0.979, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }

  41.04% {
    transform: matrix3d(0.961, 0, 0, 0, 0, 0.961, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }

  52.15% {
    transform: matrix3d(0.991, 0, 0, 0, 0, 0.991, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }

  63.26% {
    transform: matrix3d(1.007, 0, 0, 0, 0, 1.007, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }

  85.49% {
    transform: matrix3d(0.999, 0, 0, 0, 0, 0.999, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }

  100% {
    transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
}

.loading {
  padding: 16px;

  &::before {
    @include ball;
    border: none;
    animation-delay: 0.15s;
  }

  & span {
    display: block;
    font-size: 0;
    width: 20px;
    height: 10px;
    position: relative;

    &::before {
      @include ball;
      margin-left: -7px;
    }

    &::after {
      @include ball;
      margin-left: 7px;
      animation-delay: 0.3s;
    }
  }
}

@keyframes ball {
  from {
    transform: translateY(0) scaleY(0.8);
  }

  to {
    transform: translateY(-10px);
  }
}

.avatar {
  border-radius: 30px;
  width: 30px;
  height: 30px;
  overflow: hidden;
  margin: 0;
  padding: 0;
  border: 2px solid rgba(255, 255, 255, 0.24);
  margin-right: 16px;

  img {
    width: 100%;
    height: auto;
  }
}

.character-container {
  position: absolute;
  z-index: 1;
  top: -50px;
  left: 0px;
  background: #3d9bbc;
  padding: 16px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.character-name {
  font-size: 12px !important;
  font-weight: 600;
  color: #fff;
  text-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
  margin: 0;
  padding: 0;
}

.assessment-title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.assessment-container {
  width: 100%;
}

.assessment-content {
  padding-top: 32px;

  p {
    font-weight: bold;

    span {
      font-weight: normal;
    }
  }
}

h2 {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 16px;
}

.container {
  margin: 0 16px;
  width: 100%;
}
</style>